import { XlsHeaderInterface, XlsRowInterface } from 'components';

const headerCsvFormat = (key: string) => `QTD / ${key};VALOR / ${key}`;

const headerXlsFormat = (arr: XlsHeaderInterface[]) => {
  return arr
    .map((item) => {
      if (item.key !== 'labels') {
        return [
          { header: `QTD / ${item.header}`, key: 'QTD' + item.key, width: 20 },
          {
            header: `VALOR / ${item.header}`,
            key: 'VALOR' + item.key,
            width: 20,
          },
        ];
      } else {
        return item;
      }
    })
    .flatMap((e) => e);
};

const rowsXlsFormat = (arr: XlsRowInterface[][]) => {
  return arr.map((item) =>
    item
      .map((obj) => {
        const splitArr = obj.value.split('(');
        if (obj.key !== 'labels') {
          if (splitArr.length === 2) {
            return [
              {
                key: 'QTD' + obj.key,
                value: splitArr[0]
                  .replaceAll('R$', '')
                  .replaceAll(')', '')
                  .replaceAll('(', ''),
                image: obj.image,
              },
              {
                key: 'VALOR' + obj.key,
                value: splitArr[1].replaceAll('R$', '').replaceAll(')', ''),
                image: obj.image,
              },
            ];
          } else {
            return [
              {
                key: 'QTD' + obj.key,
                value: obj.value,
                image: obj.image,
              },
              {
                key: 'VALOR' + obj.key,
                value: '',
                image: obj.image,
              },
            ];
          }
        } else {
          return obj;
        }
      })
      .flatMap((e) => e),
  );
};

export { headerCsvFormat, headerXlsFormat, rowsXlsFormat };
